export default function MySQL_CEILING() {
  return (
    <div>
      <h2>MySQL_CEILING</h2>    </div>
  );
}